module.exports = __webpack_public_path__ + "img/profile-placeholder.639a7f55.png";